<div class="program-media card">
  <div class="program-media__header">
    <h4>{{ programNode?.description }}</h4>
    <span
      class="label-highlight"
      *ngIf="programNode?.labelText"
      [innerHTML]="programNode?.labelText"
    ></span>
    <div class="program-media__header-options">
      @if (programNode?.log || (currentFile && this.showProgressBar === false))
      {
      <button (click)="clearFile()" class="btn btn--ssm">
        <span>{{ 'REMOVE' | translate }}</span>
        <fa-icon [icon]="removeIcon"></fa-icon>
      </button>
      }
    </div>
  </div>

  @if (showProgressBar) {
  <mec-progress-bar
    [fileName]="fileName"
    [progressValue]="progressValue"
  ></mec-progress-bar>
  } @if (programNode?.log || (currentFile && this.showProgressBar === false)) {
  <div class="program-media__preview">
    @if (programNode?.validation?.type === 'image') {
    <img [src]="srcImage || currentFile.imageBlob" />
    } @if (programNode?.validation?.type === 'video') {
    <div class="program-media__file-container">
      <fa-icon class="program-media__preview-icon" [icon]="videoIcon"></fa-icon>
    </div>
    } @if (programNode?.validation?.type === 'file') {
    <div class="program-media__file-container">
      <fa-icon class="program-media__preview-icon" [icon]="fileIcon"></fa-icon>
    </div>
    }
  </div>
  } @if (!currentFile && !srcImage) {
  <div
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    class="program-media__container"
    [ngClass]="{ 'program-media__container--on-drag': onDrag === true }"
  >
    <fa-icon class="program-media__cloud-icon" [icon]="cloudIcon"></fa-icon>
    @if (programNode?.validation?.type === 'image') {
    <h4>{{ 'COMPONENT.CHAIN_MEDIA.DROP_IMAGE_HERE' | translate }}</h4>
    } @if (programNode?.validation?.type === 'video') {
    <h4>{{ 'COMPONENT.CHAIN_MEDIA.DROP_VIDEO_HERE' | translate }}</h4>
    } @if (programNode?.validation?.type === 'file') {
    <h4>{{ 'COMPONENT.CHAIN_MEDIA.DROP_FILE_HERE' | translate }}</h4>
    } @if (programNode?.validation?.type === 'audio') {
    <h4>{{ 'COMPONENT.CHAIN_MEDIA.DROP_FILE_HERE' | translate }}</h4>
    }
    <span>{{ 'PROGRAMS.RUN.OR' | translate }}</span>
    <button (click)="inputFile.click()" class="btn btn--sm btn-ico-rigth">
      <fa-icon [icon]="uploadIcon"></fa-icon>
      <span
        >{{ 'SETTINGS.PROFILE.MAIN.TIMEZONE.PLACEHOLDER' | translate }}
        {{ 'FILE' | translate }}</span
      >
    </button>

    <input
      #inputFile
      [accept]="acceptTypes"
      id="inputFile"
      class="program-media__file-input"
      type="file"
      (change)="loadFile($event)"
      hidden
    />
  </div>
  }
</div>
